// config.js
const config = {
    currentEvent: "LACNIC 44",
    pastEvent: "LACNIC 43", 
    REACT_APP_EVENT_SLUG:"LACNIC44",
    REACT_APP_PAST_EVENT_SLUG:"LACNIC 43",
    REACT_APP_API_URL_BASE: "https://apievt.lacnic.net/wp-json",
    REACT_APP_API_URL: "https://apievt.lacnic.net/wp-json/wp/v2",
    REACT_APP_API_URL_MENU: "https://apievt.lacnic.net/wp-json/menus/v1/menus",
    lacnogEvent: "LACNOG 2025",
    eventDate: "2025/05/05",
    // ID del evento actual
    currentEventID: 226, 
    currentEventID_en: 227, 
    currentEventID_pt_br: 228,
    // ID del evento pasada
    pastEventID: 217,
    pastEventID_en: 218,
    pastEventID_pt_br: 219,
    // Archivos de configuración Zona Horaria: HourRow.jsx, TimeZoneState.jsx
    eventTimeZone: 'America/El_Salvador',
    utcEventTimeZone: 'GMT-0600',
    currentEventCountry: 'El Salvador',
    // URLs importantes
    registrationURL: 'https://eventos.lacnic.net/ev4/detail?id=lacnic44',
    // Menu
    useAppMenu: false, // Cambia a true cuando quieras usar el menú de la app
  };
  
export default config;
  